import { render, staticRenderFns } from "./CompanyValidation.vue?vue&type=template&id=0046622c&scoped=true&"
import script from "./CompanyValidation.vue?vue&type=script&lang=js&"
export * from "./CompanyValidation.vue?vue&type=script&lang=js&"
import style0 from "./CompanyValidation.vue?vue&type=style&index=0&id=0046622c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0046622c",
  null
  
)

export default component.exports